export const gerarAmigos = (quantidade = 10) => {
  const amigos = [];
  const esportes = ['Futebol', 'Vôlei', 'Basquete', 'Futsal'];
  
  for (let i = 1; i <= quantidade; i++) {
    const nome = `Amigo Teste ${i}`;
    const esporteFavorito = esportes[Math.floor(Math.random() * esportes.length)];
    
    amigos.push({
      id: i,
      nome,
      email: `amigo${i}@teste.com`,
      avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(nome)}&background=random`,
      publico: Math.random() > 0.5,
      esporteFavorito,
      nivel: Math.floor(Math.random() * 5) + 1,
      ultimoJogo: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString()
    });
  }
  
  return amigos;
};
